import { createListenerMiddleware } from '@reduxjs/toolkit';
import { 
  addUserMessage, 
  addAssistantMessage, 
  setCurrentThreadId 
} from '@/services/websocketService';
import { RootState } from '@/app/store';
import { chatApi } from '@/services/chatApi';

export const websocketMiddleware = createListenerMiddleware();

// Listen for user messages and update the thread
websocketMiddleware.startListening({
  actionCreator: addUserMessage,
  effect: async (action, listenerApi) => {
    const userMessage = action.payload;
    
    (listenerApi.dispatch as any)(
      chatApi.util.updateQueryData('getThreads', undefined as void, (draft) => {
        const thread = draft?.find(t => t.id === userMessage.threadId);
        if (thread) {
          thread.messages.push(userMessage);
        }
      })
    );
  }
});

// Listen for assistant messages and update the thread
websocketMiddleware.startListening({
  actionCreator: addAssistantMessage,
  effect: async (action, listenerApi) => {
    const assistantMessage = action.payload;
    
    // Use a type assertion to fix the dispatch type issue
    (listenerApi.dispatch as any)(
      chatApi.util.updateQueryData('getThreads', undefined as void, (draft) => {
        const thread = draft?.find(t => t.id === assistantMessage.threadId);
        if (thread) {
          thread.messages.push(assistantMessage);
        }
      })
    );
  }
});